import { format } from 'owa-localize';

import { makePutRequest } from 'owa-ows-gateway';
import { isSuccessStatusCode } from 'owa-http-status-codes';

const setSafeLinksSettingUrl: string = 'ows/api/beta/PremiumUser/safelinks?isSafeLinksEnabled={0}';

export async function setSafeLinksSettingService(isSafeLinksEnabled: boolean): Promise<Response> {
    let response = await makePutRequest(
        format(setSafeLinksSettingUrl, isSafeLinksEnabled),
        undefined,
        undefined,
        true
    );

    if (isSuccessStatusCode(response.status)) {
        return response;
    }

    return undefined;
}
